const maintenanceModeFlag = process.env.REACT_APP_MAINTENANCE === "TRUE"

const maintenanceMode = {
  isEnabled: () => {
    return maintenanceModeFlag;
  },
};

export default maintenanceMode;
